const removeAccents = (str: string) =>
    // Normalize to NFD (normal form decomposition) and delete Combining Diacritical Marks Unicode
    // https://stackoverflow.com/a/37511463/3874587
    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const EVENT_PARAM_NAME_CHARS_LIMIT = 40;
const EVENT_PARAM_VALUE_CHARS_LIMIT = 100;

export const sanitizeAnalyticsParam = (str: string): string =>
    removeAccents(str)
        .toLocaleLowerCase()
        .replace(/[^a-z0-9\s\-\_\/\|\:]/g, '') // Remove all non allowed characters
        .replace(/\s+/g, ' ') // Replace repeated whitespaces with a single space
        .trim()
        .replace(/\s/g, '_') // Replace spaces with underscores
        .slice(0, EVENT_PARAM_VALUE_CHARS_LIMIT);

export const sanitizeAnalyticsParams = (params: Record<string, unknown>): Record<string, unknown> => {
    const sanitizedParams: Record<string, unknown> = {};

    Object.entries(params).forEach(([key, value]) => {
        const sanitizedKey = key.slice(0, EVENT_PARAM_NAME_CHARS_LIMIT);
        const sanitizedValue = typeof value === 'string' ? sanitizeAnalyticsParam(value) : value;
        sanitizedParams[sanitizedKey] = sanitizedValue;
    });

    return sanitizedParams;
};
